const DAY_IN_MS = 24 * 60 * 60 * 1000;

export const isoDaysFromNow = (days: number) => {
  return new Date(Date.now() + days * DAY_IN_MS).toISOString();
};

export const isoNow = () => {
  return new Date().toISOString();
};
